import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ContactTable from '../../../../../../common/components/ContactTable';

@connect((store, props) => {
  const companyId = parseInt(props.params.companyId, 10) || 0;
  const staticData = store.staticData;
  const contacts = store.companyContacts;

  return {
    companyId,
    staticData,
    contacts
  };
})
export default class ContactPanel extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div>
        <ContactTable
          useContactTypeDropdown={true}
          contactLink={true}
          showFilters={false}
          columns={['Name', 'Phone', 'Title', 'Type', 'Email', 'Delete']}
          contacts={this.props.contacts} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/Content/Contacts/index.js